import { createSelector } from "reselect";

/**
 * selector to determine if patient overview education is enabled
 */
export const patientOverviewEducationEnabledSelector = createSelector(
  () => false
);
